<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-card class="mt-4 mx-6 mb-4">
          <v-autocomplete
            v-model="selectedBillableID"
            class="mx-4"
            :items="billables"
            label="Select Billable Item"
            @change="getSelectedBillable()"
          >
          </v-autocomplete>

           <v-text-field
        v-if="
          (selectedBillable &&
            selectedBillable.item_type == 'billable' &&
            selectedBillable.qty_increment_id != 1) ||
          (selectedBillable && selectedBillable.item_type == 'service') ||
          (selectedBillable && selectedBillable.item_type == 'product') ||
          (selectedBillable && selectedBillable.item_type != 'transport')
        "
        class="mx-6"
        v-model="units"
        :label="
          selectedBillable.qty_increment_id &&
          (selectedBillable.qty_increment_id == 2 ||
            selectedBillable.qty_increment_id == 7)
            ? 'Minutes'
            : selectedBillable.qty_increment_id &&
              selectedBillable.qty_increment_id == 3
            ? 'Copies'
            : selectedBillable.qty_increment_id &&
              selectedBillable.qty_increment_id == 4
            ? 'Folios'
            : selectedBillable.qty_increment_id &&
              selectedBillable.qty_increment_id == 5
            ? 'Number of Calls'
            : selectedBillable.qty_increment_id &&
              selectedBillable.qty_increment_id == 6
            ? 'Number of Attendances'
            : selectedBillable.qty_increment_id &&
              selectedBillable.qty_increment_id == 8
            ? 'Number of Persons'
            : selectedBillable.qty_increment_id &&
              selectedBillable.qty_increment_id == 9
            ? 'Hours'
            : selectedBillable.qty_increment_id &&
              selectedBillable.qty_increment_id == 10
            ? 'Number of Pages'
            : selectedBillable.item_type &&
              selectedBillable.item_type == 'service'
            ? 'Hours'
            : selectedBillable.item_type &&
              selectedBillable.item_type == 'product'
            ? 'Quantity'
            : selectedBillable.item_type &&
              selectedBillable.item_type == 'transport'
            ? 'Kilometers'
            : 'Flat Fee [Nothing is required here]'
        "
      ></v-text-field>

          <DatePickerWithMenu
            label="Select Billing Date"
            @date-selected="setBillingDate"
          ></DatePickerWithMenu>

         

          <!-- <TimePicker
            label="Select Time Billing Starts"
            @time-selected="setTimeFrom"
          ></TimePicker> -->

          <!-- <TimePicker
            label="Select Time Billing Ends"
            @time-selected="setTimeBillingEnd"
          ></TimePicker> -->
          <v-container>
            <v-row class="mx-auto mb-4">
              <v-btn
                @click="billClientNow()"
                small
                rounded
                color="green"
                dark
                :disabled="!selectedBillableID"
                ><v-icon left>mdi-check</v-icon> Bill Now</v-btn
              ></v-row
            >
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12 sm8
        ><v-card class="mt-4 ml-4 mb-4">
          <v-row>
            <v-card-title v-if="selectedCase"
              >{{ selectedCase.title }} Billings</v-card-title
            >

            <v-btn
              class="mx-4 mt-6"
              x-small
              rounded
              dark
              color="#01579B"
              @click="openBillToInvoiceDialog()"
              ><v-icon left>mdi-arrow-right</v-icon>Invoice</v-btn
            >
            <v-icon color="red" @click="openConfirmDeleteDialog()" class="mr-4"
              >mdi-delete</v-icon
            >
            <v-text-field
              append-icon="mdi-magnify"
              v-model="search"
              class="mr-8"
            ></v-text-field>
          </v-row>

          <v-data-table
            :headers="billingHeaders"
            :items="billings"
            class="elevation-1"
            :search="search"
          >
            <template v-slot:item.status="{ item }">
              <div v-if="!item.status">
                <!-- <v-icon dense>mdi-pencil</v-icon> -->
                <v-checkbox
                  dense
                  v-model="selectedBills"
                  class="pa-3"
                  :value="item"
                ></v-checkbox>
              </div>
              <div v-else>
                <v-btn color="green" dark x-small>Invoiced</v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card></v-flex
      >
      <GlobalConfirmDeleteDialog
        :item="selectedBills.length > 1 ? 'Bills' : 'Bill'"
        @delete-confirmed="takeActionAfterDeleteChoice"
      ></GlobalConfirmDeleteDialog>

      <GlobalDialogSlot
        @close-dialog="closeDialog"
        :dialog="billToInvoiceDialog"
        :title="
          'Convert Selected ' +
          (selectedBills.length > 1 ? 'Bills' : 'Bill') +
          ' To Invoice'
        "
      >
        <v-card v-for="(bill, ind) in selectedBills" :key="ind + Math.random()">
          <v-card-subtitle
            >{{ bill.billing_date }} | {{ bill.description }} | {{ getCurrency
            }}{{ bill.bill }} |
            {{ !bill.status ? "Not Invoiced" : "Invoiced" }}</v-card-subtitle
          >
        </v-card>
        <v-card>
          <v-card-actions>
            <DatePickerWithMenu
              label="Select Billing Date"
              @date-selected="setBillingDate"
            ></DatePickerWithMenu>
            <v-btn
              color="green"
              dark
              class="mx-6 my-4"
              @click="convertBillToInvoiceNow()"
              rounded
              small
              ><v-icon left>mdi-arrow-right</v-icon>Invoice Now</v-btn
            >
          </v-card-actions>
        </v-card>
      </GlobalDialogSlot>
    </v-layout>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";
import GlobalConfirmDeleteDialog from "@/components/myLibrary/GlobalConfirmDeleteDialog.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";

export default {
  props: ["selCase"],

  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
  },
  mounted() {
    this.selectedCase = this.selCase;
    if (this.selCase.invoices.length > 0) {
      const primaryInvoice = this.selCase.invoices[0];
      this.invoiceNumber = primaryInvoice.invoice_number;
    }

    this.getBillablesAndBillings();
  },
  watch: {
    selCase(newCase) {
      this.selectedCase = newCase;
      if (this.newCase.invoices.length > 0) {
        const primaryInvoice = this.newCase.invoices[0];
        this.invoiceNumber = primaryInvoice.invoice_number;
      }
      this.getBillablesAndBillings();
    },
  },
  components: {
    DatePickerWithMenu,
    GlobalDialogSlot,
    GlobalConfirmDeleteDialog,
  },
  data: () => ({
    invoiceNumber: null,
    search: null,
    billToInvoiceDialog: false,
    billings: [],
    selectedBills: [],
    selectedBillsIDs: [],
    selectedBillable:null,
    units:null,
    billingHeaders: [
      { text: "Status", value: "status" },
      { text: "Date", value: "billing_date" },
      { text: "Description", value: "description" },
      { text: "Units", value: "hours" },
      { text: "Bill", value: "bill" },
    ],
    selectedBillableID: null,
    selectedCase: null,
    billables: [],
    billablesFromDatabase: [],
    timeFrom: null,
    timeBillingEnd: null,
    billingDate: new Date().toISOString().substr(0, 10),
    calculatedBillAmount: 0,
    billDescription: null,
  }),
  methods: {
    getBillablesAndBillings() {
      this.$store.commit("setLoader", true);
      this.billables = [];
      axios
        .postDataWithToken(
          "/auth/get-billings-for-selected-case",
          { caseID: this.selectedCase.id },
          this.getAccessToken
        )
        .then((billings) => {
          this.billings = billings;
          if (billings.length > 0) {
            this.selectedBills = [];

            billings.forEach((bill) => {
              if (!bill.status) {
                this.selectedBills.push(bill);
              }
            });
          }
          axios
            .postDataWithToken(
              "/auth/get-billables",
              {
                courtTypeID: this.selectedCase.court_type_id,
                scaleID: this.selectedCase.scale_id,
              },
              this.getAccessToken
            )
            .then((billables) => {
              this.billablesFromDatabase = billables;
              billables.forEach((billable) => {
                
                this.billables.push({
                  text: `${billable.name} [${this.getCurrency}${billable.cost_per_hour} ${billable.increments ? billable.increments.name :''} ]`,
                  value: billable.id,
                });
              });

              this.closeDialog();
              this.$store.commit("setLoader", false);
            });
        });
      this.closeDialog();
    },
    getSelectedBillable(){
       this.selectedBillable = this.billablesFromDatabase.find((billable) => {
          return billable.id == this.selectedBillableID;
        });
        
    },
    setTimeFrom(timeFrom) {
      this.timeFrom = timeFrom;
    },
    setTimeBillingEnd(timeBillingEnd) {
      this.timeBillingEnd = timeBillingEnd;
    },
    setBillingDate(billingDate) {
      this.billingDate = billingDate;
    },
    billClientNow() {
      this.$store.commit("setLoader", true);
      let total = 0;
      let units = this.units ? Number(this.units) : 1;

      if (
        this.selectedBillable.qty_increment_id &&
        this.selectedBillable.qty_increment_id == 2
      ) {
        units = this.units ? Number(this.units) : 15;
        units = (units / 15).toFixed(2);
      } else if (
        this.selectedBillable.qty_increment_id &&
        this.selectedBillable.qty_increment_id == 7
      ) {
        units = this.units ? Number(this.units) : 5;
        units = (units / 5).toFixed(2);
      }

      if (this.selectedBillable && this.selectedBillable.cost_per_hour) {
        total = (Number(units) * Number(this.selectedBillable.cost_per_hour)).toFixed(
          2
        );
      }
      //const date = new Date();
      //let froms = "";
      //let tos = "";
     // if (this.timeFrom && this.timeBillingEnd) {
        // froms = this.timeFrom.split(":");
        // tos = this.timeBillingEnd.split(":");

        // const dateFrom = new Date(
        //   date.getFullYear(),
        //   date.getMonth(),
        //   date.getDate(),
        //   froms[0],
        //   froms[1]
        // );

        // const dateTo = new Date(
        //   date.getFullYear(),
        //   date.getMonth(),
        //   date.getDate(),
        //   tos[0],
        //   tos[1]
        // );

        // const selectedBillable = this.billablesFromDatabase.find((billable) => {
        //   return billable.id == this.selectedBillableID;
        // });

        //let diffInMilliSeconds = Math.abs(dateTo - dateFrom) / 1000;

        // calculate hours
        // let hours = ((diffInMilliSeconds / 3600) % 24).toFixed(2);
        // diffInMilliSeconds -= hours * 3600;

        // if (selectedBillable.qty_increment_id == 2) {
        //   hours = (hours * 4).toFixed(2);
        // } else if (selectedBillable.qty_increment_id == 7) {
        //   hours = (hours * 12).toFixed(2);
        // }

        let calculatedBillAmount =
          Number(total) * Number(units);
        calculatedBillAmount = calculatedBillAmount.toFixed(2);
        this.calculatedBillAmount = calculatedBillAmount;

        this.billDescription = this.selectedBillable.name;
        const data = {
          caseID: this.selectedCase.id,
          staffID: this.getCurrentUser.id,
          scaleID: this.selectedCase.scale_id,
          courtTypeID: this.selectedCase.court_type_id,
          attorneyTypeID: this.selectedCase.attorney_type_id,
          clientRef: this.selectedCase.client_reference,
          description: this.selectedBillable.name,
          billableID: this.selectedBillable.id,
          billableDate: this.billingDate,
          billableFrom: this.timeFrom,
          billableTo: this.timeBillingEnd,
          bill: calculatedBillAmount,
          hours: units,
          invoiceNumber: this.invoiceNumber,
        };

        axios
          .postDataWithToken(
            "/auth/add-billing-to-file",
            data,
            this.getAccessToken
          )
          .then((bills) => {
            this.billings = bills;
            this.$emit("refresh-needed");
            this.$store.commit("setLoader", false);
            this.closeDialog();
          });
      //}
    },
    openBillToInvoiceDialog() {
      if (this.selectedBills.length < 1) {
        this.$router.push({
          name: "edit-and-print-invoice",
          params: {
            selectedInvoice: {
              client: this.selectedCase.client,
              invoiceNumber: this.invoiceNumber,
              caseID: this.selectedCase.id,
            },
          },
        });
      } else {
        this.billToInvoiceDialog = true;
      }
    },
    convertBillToInvoiceNow() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/convert-bills-to-invoice",
          {
            bills: this.selectedBills,
            clientRef: this.selectedCase.client_reference,
            billingDate: this.billingDate,
            caseID: this.selectedCase.id,
            invoiceNumber: this.invoiceNumber,
          },
          this.getAccessToken
        )
        .then((invoiceData) => {
          this.$store.commit("setLoader", false);
          this.$router.push({
            name: "edit-and-print-invoice",
            params: { selectedInvoice: invoiceData },
          });
        });
    },
    openConfirmDeleteDialog() {
      if (this.selectedBills.length < 1) {
        alert("You Must Select At Least One (1) Item");
        event.preventDefault();
      } else {
        this.$store.commit("setGlobalConfirmDelete", true);
      }
    },
    takeActionAfterDeleteChoice(choice) {
      if (choice) {
        this.selectedBillsIDs = [];
        this.selectedBills.forEach((bill) => {
          this.selectedBillsIDs.push(bill.id);
        });
        this.bulkDeleteItems(this.selectedBillsIDs);
      }
    },
    bulkDeleteItems(rowIds) {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/bulk-delete",
          { table: "billings", rowIds },
          this.getAccessToken
        )
        .then((response) => {
          this.$store.commit("setLoader", false);
          this.$emit("refresh-needed");
          this.closeDialog();
          this.getBillablesAndBillings();
        });
    },
    closeDialog() {
      this.selectedBillsIDs = [];
      this.selectedBillableID = null;
      this.timeFrom = null;
      this.timeBillingEnd = null;
      this.billToInvoiceDialog = false;
    },
  },
};
</script>

<style></style>
